import { render, staticRenderFns } from "./ApiKeySettingsHeader.vue?vue&type=template&id=b3c827bc&scoped=true&"
import script from "./ApiKeySettingsHeader.vue?vue&type=script&lang=js&"
export * from "./ApiKeySettingsHeader.vue?vue&type=script&lang=js&"
import style0 from "./ApiKeySettingsHeader.vue?vue&type=style&index=0&id=b3c827bc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3c827bc",
  null
  
)

export default component.exports